export default "__VITE_ASSET__wkx8RFdL__"